import { Calendar, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectFetchedEvents } from "@/store/redux/slices/event/event_slice";
import "@/assets/styles/home_calender.css";

const HomeCalender = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const events = useSelector(selectFetchedEvents) || [];

  const wrapperStyle = {
    border: `0px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    height: "100%",
    width: "100%",
  };

  // Function to check if a date has events
  const getEventsForDate = (date) => {
    if (!events || !Array.isArray(events)) return [];

    const formattedDate = date.format("YYYY-MM-DD");
    return events.filter((event) => {
      // Check if the event's start date matches this date
      const eventStartDate = event?.schedule?.startDate;
      if (!eventStartDate) return false;

      // Convert event date to YYYY-MM-DD format for comparison
      const eventDate = new Date(eventStartDate);
      // Use consistent date formatting method
      const eventFormattedDate = eventDate.toISOString().split("T")[0];

      return eventFormattedDate === formattedDate;
    });
  };

  // Custom date cell renderer to apply random color class for events
  const dateCellRender = (date) => {
    const eventsForDate = getEventsForDate(date);

    if (eventsForDate.length > 0) {
      // Use date as a seed for consistent color assignment
      const dateNum = parseInt(date.format("YYYYMMDD"), 10);
      const isGreen = dateNum % 2 === 0; // Even dates get green, odd get warning

      const colorClass = isGreen ? "event-green" : "event-warning";
      return <div className={`has-events ${colorClass}`}></div>;
    }

    return null;
  };

  // New cellRender function that works with the updated API
  const cellRender = (current, info) => {
    if (info.type === "date") {
      return dateCellRender(current);
    }
    return info.originNode;
  };

  // Handler for date cell clicks
  const handleDateClick = (date) => {
    const formattedDate = date.format("YYYY-MM-DD");
    const eventsForDate = getEventsForDate(date);

    if (eventsForDate.length > 0) {
      // Navigate to events page with date filter
      navigate(`/dashboard/events?date=${formattedDate}`);
    }
  };

  return (
    <div className="h-full w-full">
      <div style={wrapperStyle} className="h-full w-full">
        <h2 className="text-xl font-bold">Calendar</h2>
        <Calendar
          fullscreen={false}
          cellRender={cellRender}
          onSelect={handleDateClick}
          className="event-calendar w-full"
        />
      </div>
    </div>
  );
};

export default HomeCalender;
